export default {
  headers: {
    edit_time: 'Editar horário',
    create_time: 'Criar horário',
  },
  labels: {
    select_all: 'Selecionar tudo',
  },
  buttons: {
    add_opening_time: 'Adicionar horário de abertura',
    add: 'Adicionar',
    cancel: 'Cancelar',
  },
};
